var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6066 2.5H6.55992C6.15867 2.5 5.83325 2.82542 5.83325 3.22667V6.25125H18.3333V3.22667C18.3333 2.82542 18.0078 2.5 17.6066 2.5Z",
    fill: "#2D92D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 13.7725V16.7733C5.83325 17.1746 6.15867 17.5 6.5595 17.5H17.6066C18.0078 17.5 18.3333 17.1746 18.3333 16.7733V13.7725H5.83325Z",
    fill: "#2150A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 6.25125H18.3333V10.0021H5.83325V6.25125Z",
    fill: "#2D83D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 10.0021H18.3333V13.7729H5.83325V10.0021Z",
    fill: "#2E70C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29966 14.1667H2.36716C1.9805 14.1667 1.66675 13.8529 1.66675 13.4662V6.53374C1.66675 6.14708 1.9805 5.83333 2.36716 5.83333H9.29966C9.68633 5.83333 10.0001 6.14708 10.0001 6.53374V13.4662C10.0001 13.8529 9.68633 14.1667 9.29966 14.1667Z",
    fill: "#00488D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.668 7.91667L7.02384 10.9433L6.31009 7.91667H5.39884L4.66259 11.0371L3.99884 7.91667H3.18384L4.1605 12.0833H5.1405L5.85425 8.87959L6.56842 12.0833H7.50634L8.483 7.91667H7.668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/Word.c24a89936967c0a347d07b18b7dd2e13.svg";
export { ForwardRef as ReactComponent };